module.exports = __webpack_public_path__ + "static/media/logo_text1.1c530590.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo_text1.svg
// module id = 214
// module chunks = 0